import { render, staticRenderFns } from "./dailyPaper2.vue?vue&type=template&id=3da4d7dd&scoped=true"
import script from "./dailyPaper2.vue?vue&type=script&lang=js"
export * from "./dailyPaper2.vue?vue&type=script&lang=js"
import style0 from "./dailyPaper2.vue?vue&type=style&index=0&id=3da4d7dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da4d7dd",
  null
  
)

export default component.exports